module.exports = __webpack_public_path__ + "img/日内瓦国际发明奖_金奖.3ead0e5c.png";